import React from 'react';
import {Alert, Button, Input, Label} from 'reactstrap';
import fetch from "./fetch";
import {setTitle} from "./util";

class Settings extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            pd_weight: 10,
            gm_weight: 10,
            cal_weight: 10,
            mgj_weight: 10,
            fg_weight: 10,
            bld_weight: 10,
            sup_weight: 10,
            mob_weight: 10,
            pla_weight: 10,
            bl_weight: 10,
            br_score_weight: 33,
            br_freq_weight: 33,
            br_length_weight: 33,
            visible: false
        };
    }

    componentWillMount() {
    }

    componentDidMount() {
        setTitle('Analytical Configuration');

        this.getPreferences();
    }

    setPreferences() {
        fetch('/api/v1/preferences', {
            method: 'POST',
            headers: {
                Accept: `application/json`,
                'Content-type': `application/json`
            },
            body: JSON.stringify({
                pd_weight: parseInt(this.state.pd_weight, 10),
                gm_weight: parseInt(this.state.gm_weight, 10),
                cal_weight: parseInt(this.state.cal_weight, 10),
                mgj_weight: parseInt(this.state.mgj_weight, 10),
                fg_weight: parseInt(this.state.fg_weight, 10),
                bld_weight: parseInt(this.state.bld_weight, 10),
                sup_weight: parseInt(this.state.sup_weight, 10),
                mob_weight: parseInt(this.state.mob_weight, 10),
                pla_weight: parseInt(this.state.pla_weight, 10),
                bl_weight: parseInt(this.state.bl_weight, 10),
                br_score_weight: parseInt(this.state.br_score_weight, 10),
                br_freq_weight: parseInt(this.state.br_freq_weight, 10),
                br_length_weight: parseInt(this.state.br_length_weight, 10)
            })
        })
            .then(async (resp) => {
                if (!resp || !resp.ok) {
                    return;
                }
                this.setState({
                    visible: true
                });
            })
            .catch((err) => {
                console.error('Could save preferences', err);
            });
    }

    resetDefaults() { // @TODO change for sane defaults
        this.setState({
            pd_weight: 25,
            gm_weight: 5,
            cal_weight: 5,
            mgj_weight: 5,
            fg_weight: 6,
            bld_weight: 25,
            sup_weight: 5,
            mob_weight: 7,
            pla_weight: 7,
            bl_weight: 10,
            br_score_weight: 33,
            br_freq_weight: 33,
            br_length_weight: 33
        });
    }

    getPreferences() {
        fetch('/api/v1/preferences', {
            method: 'GET',
        })
            .then(async (resp) => {
                if (!resp || !resp.ok) {
                    return;
                }
                let body = await resp.json();
                this.setState(body);
            })
            .catch((err) => {
                console.error('Could not fetch preferences', err);
            });
    }

    handleWeightChange(e) {
        switch (e.target.id) {
            case "pb":
                this.setState({
                    pd_weight: e.target.value
                });
                break;
            case "gm":
                this.setState({
                    gm_weight: e.target.value
                });
                break;
            case "cal":
                this.setState({
                    cal_weight: e.target.value
                });
                break;
            case "mgj":
                this.setState({
                    mgj_weight: e.target.value
                });
                break;
            case "fg":
                this.setState({
                    fg_weight: e.target.value
                });
                break;
            case "bld":
                this.setState({
                    bld_weight: e.target.value
                });
                break;
            case "sup":
                this.setState({
                    sup_weight: e.target.value
                });
                break;
            case "pla":
                this.setState({
                    pla_weight: e.target.value
                });
                break;
            case "mob":
                this.setState({
                    mob_weight: e.target.value
                });
                break;
            case "bl":
                this.setState({
                    bl_weight: e.target.value
                });
                break;
            case "br_length":
                this.setState({
                    br_length_weight: e.target.value
                });
                break;
            case "br_freq":
                this.setState({
                    br_freq_weight: e.target.value
                });
                break;
            case "br_score":
                this.setState({
                    br_score_weight: e.target.value
                });
                break;
            default:
                break;
        }
    }

    onDismiss() {
        this.setState({
            visible: false
        });
    }

    render() {
        return (
            <div>
                <h2 id="title">Analytical Configuration</h2> <br />
                <Alert color="info" isOpen={this.state.visible} toggle={this.onDismiss.bind(this)}>
                    Configuration updated
                </Alert>
                <h4>Here you can modify how much a section of the grades counts towards the final score. If they are set to zero, they will not be used to calculate the patients final perio or brushing scores.</h4>
                <div className="d-flex flex-row justify-content-between p-5">
                    <div className="d-flex flex-column">
                        <h3>Perio Analytics</h3>
                        <div className="d-flex flex-row">
                            <div>
                                <div className="p-3">
                                    <Label for="perio_probing" className="weight_label">Probing Depth: {this.state.pd_weight}%</Label>
                                    <Input id="pb" name="perio_probing" type="range" value={this.state.pd_weight} onChange={this.handleWeightChange.bind(this)} />
                                </div>
                                <div className="p-3">
                                    <Label for="perio_gm" className="weight_label">Gingival Margin: {this.state.gm_weight}%</Label>
                                    <Input id="gm" name="perio_gm" type="range" value={this.state.gm_weight} onChange={this.handleWeightChange.bind(this)} />
                                </div>
                                <div className="p-3">
                                    <Label for="perio_cal" className="weight_label">Clinical Attachment Level: {this.state.cal_weight}%</Label>
                                    <Input id="cal" name="perio_cal" type="range" value={this.state.cal_weight} onChange={this.handleWeightChange.bind(this)} />
                                </div>
                                <div className="p-3">
                                    <Label for="perio_mgj" className="weight_label">Mucco Gingival Junction: {this.state.mgj_weight}%</Label>
                                    <Input id="mgj" name="perio_mgj" type="range" value={this.state.mgj_weight} onChange={this.handleWeightChange.bind(this)} />
                                </div>
                                <div className="p-3">
                                    <Label for="perio_furcation" className="weight_label">Furcation Grade: {this.state.fg_weight}%</Label>
                                    <Input id="fg" name="perio_furcation" type="range" value={this.state.fg_weight} onChange={this.handleWeightChange.bind(this)} />
                                </div>
                                </div>
                            <div>
                                <div className="p-3">
                                    <Label for="perio_bleeding" className="weight_label">Bleeding: {this.state.bld_weight}%</Label>
                                    <Input id="bld" name="perio_bleeding" type="range" value={this.state.bld_weight} onChange={this.handleWeightChange.bind(this)} />
                                </div>
                                <div className="p-3">
                                    <Label for="perio_probing" className="weight_label">Suppuration: {this.state.sup_weight}%</Label>
                                    <Input id="sup" name="perio_supp" type="range" value={this.state.sup_weight} onChange={this.handleWeightChange.bind(this)} />
                                </div>
                                <div className="p-3">
                                    <Label for="perio_pla" className="weight_label">Plaque: {this.state.pla_weight}%</Label>
                                    <Input id="pla" name="perio_pla" type="range" value={this.state.pla_weight} onChange={this.handleWeightChange.bind(this)} />
                                </div>
                                <div className="p-3">
                                    <Label for="perio_mob" className="weight_label">Mobility: {this.state.mob_weight}%</Label>
                                    <Input id="mob" name="perio_mob" type="range" value={this.state.mob_weight} onChange={this.handleWeightChange.bind(this)} />
                                </div>
                                <div className="p-3">
                                    <Label for="perio_bl" className="weight_label">Bone loss: {this.state.bl_weight}%</Label>
                                    <Input id="bl" name="perio_bl" type="range" value={this.state.bl_weight} onChange={this.handleWeightChange.bind(this)} />
                                </div>
                                </div>
                        </div>
                    </div>
                </div>
                <div className="d-flex flex-row justify-content-end">
                    <Button color="info" className="mt-1" onClick={this.resetDefaults.bind(this)}>Reset to Defaults</Button>
                    <Button color="info" className="mt-1 ml-3" onClick={this.setPreferences.bind(this)}>Save configuration</Button>
                </div>
            </div>
        );
    }
}

export default Settings;